const DecisionTypes = {
  singleChoice: 'singleChoice',
  multipleChoice: 'multipleChoice',
  passFail: 'passFail',
};

export default DecisionTypes;
